const THEME_STORAGE_KEY = 'appTheme';

const defaultTheme = {
  brandPrimary: process.env.REACT_APP_THEME_PRIMARY || '#0c5aa6',
  brandPrimaryStrong: process.env.REACT_APP_THEME_PRIMARY_STRONG || '#094b8a',
  brandPrimarySoft: process.env.REACT_APP_THEME_PRIMARY_SOFT || '#eaf3ff',
  pageBg: process.env.REACT_APP_THEME_PAGE_BG || '#eef3f8',
  surface: process.env.REACT_APP_THEME_SURFACE || '#f8fbff',
  surfaceElevated: process.env.REACT_APP_THEME_SURFACE_ELEVATED || '#ffffff',
  border: process.env.REACT_APP_THEME_BORDER || '#d6e0ed',
  text: process.env.REACT_APP_THEME_TEXT || '#1f2a3d',
  textSubtle: process.env.REACT_APP_THEME_TEXT_SUBTLE || '#6d7a8f',
  textMuted: process.env.REACT_APP_THEME_TEXT_MUTED || '#8b96a8',
};

function getStoredTheme() {
  if (typeof window === 'undefined') return {};
  const raw = window.localStorage.getItem(THEME_STORAGE_KEY);
  if (!raw) return {};
  try {
    return JSON.parse(raw);
  } catch {
    return {};
  }
}

export function getAppTheme() {
  return { ...defaultTheme, ...getStoredTheme() };
}

export function applyAppTheme(theme = getAppTheme()) {
  if (typeof document === 'undefined') return;
  const root = document.documentElement;
  root.style.setProperty('--page-bg', theme.pageBg);
  root.style.setProperty('--surface', theme.surface);
  root.style.setProperty('--surface-elevated', theme.surfaceElevated);
  root.style.setProperty('--border', theme.border);
  root.style.setProperty('--text', theme.text);
  root.style.setProperty('--text-subtle', theme.textSubtle);
  root.style.setProperty('--text-muted', theme.textMuted);
  root.style.setProperty('--brand-primary', theme.brandPrimary);
  root.style.setProperty('--brand-primary-strong', theme.brandPrimaryStrong);
  root.style.setProperty('--brand-primary-soft', theme.brandPrimarySoft);
}

export function saveAppTheme(themePatch) {
  if (typeof window === 'undefined') return;
  const nextTheme = { ...getAppTheme(), ...themePatch };
  window.localStorage.setItem(THEME_STORAGE_KEY, JSON.stringify(nextTheme));
  applyAppTheme(nextTheme);
}
